import React from 'react';
import { useIsCompact } from '../../hooks/useBreakpoint';
import ThemePreferenceToggle from './ThemePreferenceToggle';

const ThemeSwitcher: React.FC = () => {
  const isCompact = useIsCompact();
  return <ThemePreferenceToggle compact={isCompact} />;
};

export default ThemeSwitcher;
